export enum ExcludedOnlyRegTrackModeComponent {
  AddSiteBtn = 'addSiteBtn',
  BecomePartnerUrl = 'becomePartnerUrl',
  SearchField = 'searchField',
  HeaderControls = 'headerControls',
  Subscriptions = 'subscriptions',
  Billing = 'billing',
}

export interface OnlyRegTrackModeSettings {
  navigation: {
    [ExcludedOnlyRegTrackModeComponent.AddSiteBtn]: boolean;
    [ExcludedOnlyRegTrackModeComponent.BecomePartnerUrl]: boolean;
  };
  header: {
    [ExcludedOnlyRegTrackModeComponent.SearchField]: boolean;
    [ExcludedOnlyRegTrackModeComponent.HeaderControls]: boolean;
  };
  userMenu: {
    [ExcludedOnlyRegTrackModeComponent.Subscriptions]: boolean;
    [ExcludedOnlyRegTrackModeComponent.Billing]: boolean;
  };
}
